import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FiltriInviateDto, InviateListDto, InviateTabDto } from '../../model/domande-data';
import { FormGroup, FormControl } from '@angular/forms';
import { GruppoValore } from '../../model/iscritti-data';
import { Table } from 'primeng/table';
import { DomandeService } from '../../services/domande.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tabella-gestione-domande',
  templateUrl: './tabella-gestione-domande.component.html',
  styleUrl: './tabella-gestione-domande.component.scss'
})
export class TabellaGestioneDomandeComponent implements OnInit {
  @ViewChild('dt') dt!: Table;

  private route = inject(ActivatedRoute);
  private domande_service = inject(DomandeService);
  public translate = inject(TranslateService);

  resetFlag: boolean = false;
  initialFlagHandler: boolean = true;

  componente: string = '';

  sezioniDropdown: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A' },
    { nome: 'Sezione B', valore: 'B' }
  ];

  //filtro generale per tutti i tipi di tabella
  filtri = new FormGroup({
    stringaFiltro: new FormControl<string|null>(''),
    sezione: new FormControl<GruppoValore|null>(null),
  })

  orderColumnName: string = '';
  order: string = 'ASC';
  pageSize: number = 25;
  pageSelected: number = 0;
  currentPage: number = 0;
  totaleDati: number = 0;

  listaIscrizioni: InviateTabDto[] = [];

  //dati della tabella
  headersTabella: string[] = ['N° Domanda', 'Data Domanda', 'Codice Fiscale', 'Nome', 'Cognome', 'Sezione']
  rowsTabella: string[] = ['domandaProtocollo', 'domandaData', 'codiceFiscale', 'nome', 'cognome', 'sezioneAlbo']

  ngOnInit(): void {
    this.initialDataHandler();

    this.filtri.valueChanges.subscribe(() => {
      this.resetPagination();
      this.loadData();
    })
  }

  initialDataHandler(){
    const data: InviateListDto = this.route.snapshot.data['inviateList'];

    this.componente = this.route.snapshot.data['componente'];

    this.listaIscrizioni = data.listaInviate;
    this.totaleDati = data.conteggio;
  }

  loadData(){

    const values = this.filtri.value;

    const data: FiltriInviateDto = {
      stringaFiltro: values.stringaFiltro!,
      sezioneAlbo: values.sezione?.valore! ? values.sezione?.valore : '',
      orderColumn: this.orderColumnName,
      order: this.order,
      page: this.pageSelected,
      pageSize: this.pageSize
    }

    this.domande_service.getDomandeInviate(data).subscribe({
      next: result => {
        this.listaIscrizioni = result.listaInviate;
        this.totaleDati = result.conteggio;
      },
      error: err => {
        console.log(err);
      }
    });

  }

  //cambio pagina della tabella
  pageChange(event: any){
    this.currentPage = event.first;
    this.pageSelected = event.page;
    this.pageSize = event.rows;

    this.loadData();
  }
  ordinamento(event: any){
    if(this.initialFlagHandler){
      this.initialFlagHandler = false;
      return;
    }

    this.orderColumnName = event.sortField ? event.sortField : 'domandaProtocollo';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.pageSize = 25;
    this.pageSelected = 0;
    this.currentPage = 0;

    if(this.resetFlag){
      this.resetFlag = false;
      this.dt.reset();
      return;
    }

    this.loadData();
  }
  orderCustom(order: string): number{
    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;

    return check;
  }

  //resetta i filtri di ricerca
  clearFilters(){
    this.resetPagination();
    this.filtri.reset({}, { emitEvent: false });
    this.dt.reset();
    this.loadData();
  }
  resetPagination(){
    this.orderColumnName = 'domandaProtocollo';
    this.order = 'ASC';
    this.pageSize = 25;
    this.pageSelected = 0;
    this.currentPage = 0;
  }
  resetBoxRicerca(){
    this.filtri.get('stringaFiltro')?.setValue('');
  }
}